// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3iDes","productName":"Table_productName__2XLwC"};